import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBuilders, getSellers } from 'shared/selectors/newbuildingHeader';

export function useBuilderChatButtonContextValue() {
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);

  return useMemo(
    () => ({
      builders: builders ?? /* istanbul ignore next */ [],
      sellers: sellers ?? /* istanbul ignore next */ [],
    }),
    [builders, sellers],
  );
}
